import React, { useEffect, useState } from 'react'
import ZenDesk from "react-zendesk";
import { ZendeskAPI } from "react-zendesk";
import { useSelector } from 'react-redux';

const zenDeskWidgetEnabled = process.env.REACT_APP_ZENDESK_ENABLED === "true";
const zenDeskKey = process.env.REACT_APP_ZENDESK_KEY;
const zenDeskProduct = process.env.REACT_APP_ZENDESK_PRODUCT;
const zenDeskProductID = process.env.REACT_APP_ZENDESK_PRODUCT_ID;
const zenDeskSettings = {
  contactForm: {
    fields: [{ id: zenDeskProductID, prefill: { "*": zenDeskProduct } }],
  },
};

const ZendeskWidget = (props) => {
  const [isRendered, setRendered] = useState(false);
  const userProfile = useSelector(store => store.auth.userProfile);
  const isAuthorized = useSelector(store => store.auth.authToken.token && store.auth.csrfToken.token && store.auth.userProfile);
  // const { location: { pathname } } = props;

  const toggleZendeskWidget = () => {
    const { location: { pathname } } = props;
    if (isAuthorized && zenDeskWidgetEnabled && isRendered) {
      if (pathname.startsWith("/admin") || pathname.includes("settings")) {
        ZendeskAPI("webWidget", "hide");
      }
      else {
        ZendeskAPI("webWidget", "show");
      }
    }
  }

  useEffect(() => {
    toggleZendeskWidget();
  }, [props, isAuthorized, isRendered]);
  return (
    <>
      {
        (isAuthorized && zenDeskWidgetEnabled) && (
          <ZenDesk
            defer
            zendeskKey={zenDeskKey}
            {...zenDeskSettings}
            onLoaded={() => {
              setRendered(true);
              // toggleZendeskWidget();
              ZendeskAPI("webWidget", "prefill", {
                name: {
                  value: userProfile.name,
                  readOnly: true,
                },
                email: {
                  value: userProfile.email,
                  readOnly: true,
                },
              });
            }}
          />
        )
      }
    </>
  );
};

export default ZendeskWidget;